module.exports = __webpack_public_path__ + "img/resLevelBar.f19d1b29.svg";